import styled from 'styled-components';
import { regulatorLabels } from '../../../../../../../consts/regulators';
import { PermissionGuard, DENY_REASONS } from '../../../../../../../components/PermissionGuard';

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99996 2.66667C8.36815 2.66667 8.66663 2.96515 8.66663 3.33334V7.33334H12.6666C13.0348 7.33334 13.3333 7.63181 13.3333 8C13.3333 8.36819 13.0348 8.66667 12.6666 8.66667H8.66663V12.6667C8.66663 13.0349 8.36815 13.3333 7.99996 13.3333C7.63177 13.3333 7.33329 13.0349 7.33329 12.6667V8.66667H3.33329C2.9651 8.66667 2.66663 8.36819 2.66663 8C2.66663 7.63181 2.9651 7.33334 3.33329 7.33334H7.33329V3.33334C7.33329 2.96515 7.63177 2.66667 7.99996 2.66667Z"
      fill="#228BE6"
    />
  </svg>
);

export const NoJurisdictions = ({
  onClick,
  selectedRegulator,
  isLoadingFunds,
  canManageWorkflow = true,
  isLockedPeriod = false
}) => {
  const allowed = canManageWorkflow && !isLockedPeriod;
  const denyReason = isLockedPeriod ? DENY_REASONS.LOCKED_PERIOD : DENY_REASONS.NO_PERMISSION;

  return (
    <Container>
      <p className="label">
        Jurisdictions have not been added yet.
        <br /> Click the button below to add a jurisdiction.
      </p>

      <PermissionGuard allowed={allowed} reason={denyReason}>
        <button type="button" onClick={onClick} disabled={isLoadingFunds}>
          {isLoadingFunds ? (
            <span>Loading Funds...</span>
          ) : (
            <>
              <PlusIcon /> <span>Add {regulatorLabels[selectedRegulator]} Jurisdiction</span>
            </>
          )}
        </button>
      </PermissionGuard>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 108px 0;
  flex-direction: column;

  .label {
    color: #adb5bd;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  button {
    &:disabled {
      border: 1px solid #ccc !important;
      color: #ccc !important;
      cursor: not-allowed;
    }

    display: flex;
    height: 32px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid #228be6;
    color: #228be6;
  }
`;
